var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnAppX = function SvgIcnAppX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.176 3.86h2.76l-6.03 6.892L21 20.13h-5.554l-4.35-5.688-4.979 5.688H3.355l6.45-7.371L3 3.86h5.695l3.933 5.199 4.548-5.199Zm-.969 14.618h1.53L7.864 5.425h-1.64l9.983 13.053Z",
    fill: "#595959"
  })));
};
export default SvgIcnAppX;